import React from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import LoginBrandingPanel from '@/components/LoginBrandingPanel';
import LoginForm from '@/components/LoginForm';
import PublicFooter from '@/components/PublicFooter';

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin/dashboard';

  // Only short-circuit when an admin is already logged in. Without the role
  // guard, a logged-in partner/customer visiting /admin/login would bounce
  // to /admin/dashboard, ProtectedRoute would kick them back to /admin/login,
  // creating an infinite redirect loop ("Maximum update depth exceeded").
  if (user && user.role === 'admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const handleSubmit = async (email, password) => {
    const result = await login(email, password);
    if (result.ok) {
      navigate(from, { replace: true });
    }
    return result;
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex flex-1">
        <LoginBrandingPanel />
        <div className="flex flex-1 items-center justify-center bg-white px-6 py-12">
          <div className="w-full max-w-md">
            <LoginForm onSubmit={handleSubmit} loading={loading} />
            <PublicFooter variant="minimal" />
          </div>
        </div>
      </div>
    </div>
  );
}
